import { KnmCollapse } from '../../KnmPackage/MainModule/components/KnmCollapse';
import { IGroupAssignmentConditionsForm } from '../PassportGroupFormModule/interfaces/IGroupAssignmentConditionsForm';
import { Row } from '../../UIPackage/FormModule/components/Row';
import { TextInput } from '../../UIPackage/MainModule/components/TextInput';
import styles from '../PassportGroupFormModule/components/CommonGroupCondition.module.scss';
import { FieldBlock } from '../../UIPackage/FormModule/components/FieldBlock';
import { SelectInput } from '../../UIPackage/MainModule/components/SelectInput';

interface IPassportGroupDetailAssignmentConditionsProps {
  condition: IGroupAssignmentConditionsForm | undefined;
}

export const PassportGroupDetailAssignmentConditions = ({
  condition,
}: IPassportGroupDetailAssignmentConditionsProps) => {
  if (!condition || !Object.values(condition).find(item => !!item)) {
    return null;
  }

  return (
    <KnmCollapse title="Сведения о поручении мероприятий">
      <>
        {!!condition.assigmentStartDate && !!condition.assigmentEndDate && (
          <Row title="Дата поручения о проведении мероприятий (интервал)" justify="start" align="center">
            <TextInput value={condition.assigmentStartDate} disabled />
            <span className={styles.DateFieldsSpace}>—</span>
            <TextInput value={condition.assigmentEndDate} disabled />
          </Row>
        )}
        {!!condition.assignmentNumbers?.length && (
          <FieldBlock label="Номера поручений о проведении мероприятий" margin="bottom">
            <SelectInput value={condition.assignmentNumbers} isMulti disabled />
          </FieldBlock>
        )}
      </>
    </KnmCollapse>
  );
};
